import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';

const Home = lazy(() => import('../pages/home/page'));
const Products = lazy(() => import('../pages/products/page'));
const ProductDetail = lazy(() => import('../pages/product-detail/page'));
const Cart = lazy(() => import('../pages/cart/page'));
const Payment = lazy(() => import('../pages/payment/page'));
const PaymentSuccess = lazy(() => import('../pages/payment-success/page'));
const Auth = lazy(() => import('../pages/auth/page'));
const Account = lazy(() => import('../pages/account/page'));
const MyOrders = lazy(() => import('../pages/my-orders/page'));
const OrderDetail = lazy(() => import('../pages/order-detail/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const BlogPost = lazy(() => import('../pages/blog-post/page'));
const About = lazy(() => import('../pages/about/page'));
const ShippingReturns = lazy(() => import('../pages/shipping-returns/page'));
const OrderConfirmation = lazy(() => import('../pages/order-confirmation/page'));
const OrderTracking = lazy(() => import('../pages/order-tracking/page'));
const Wishlist = lazy(() => import('../pages/wishlist/page'));
const ShippingConfirmation = lazy(() => import('../pages/shipping-confirmation/page'));
const AdminLogin = lazy(() => import('../pages/admin-login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/page'));
const AdminProducts = lazy(() => import('../pages/admin-products/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/products',
    element: <Products />,
  },
  {
    path: '/product/:id',
    element: <ProductDetail />,
  },
  {
    path: '/panier',
    element: <Cart />,
  },
  {
    path: '/cart',
    element: <Cart />,
  },
  {
    path: '/payment',
    element: <Payment />,
  },
  {
    path: '/payment-success',
    element: <PaymentSuccess />,
  },
  {
    path: '/login',
    element: <Auth />,
  },
  {
    path: '/account',
    element: <Account />,
  },
  {
    path: '/my-orders',
    element: <MyOrders />,
  },
  {
    path: '/order-detail',
    element: <OrderDetail />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPost />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/shipping-returns',
    element: <ShippingReturns />,
  },
  {
    path: '/order-confirmation',
    element: <OrderConfirmation />,
  },
  {
    path: '/order-tracking',
    element: <OrderTracking />,
  },
  {
    path: '/wishlist',
    element: <Wishlist />,
  },
  {
    path: '/shipping-confirmation',
    element: <ShippingConfirmation />,
  },
  {
    path: '/admin-login',
    element: <AdminLogin />,
  },
  {
    path: '/admin',
    element: <ProtectedRoute redirectTo="/admin-login"><AdminDashboard /></ProtectedRoute>,
  },
  {
    path: '/admin/products',
    element: <ProtectedRoute redirectTo="/admin-login"><AdminProducts /></ProtectedRoute>,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
